<template>
  <div id="app" class="app-main">
    <router-view/>
  </div>
</template>

<script>
  import {getScrollTop, getWindowHeight, getScrollHeight} from './common/util/dom'

  export default {
    name: 'App',
    mounted () {
      // 监听window 滚动事件
      window.onscroll = () => {
        if (getScrollTop() + getWindowHeight() >= getScrollHeight() - 50) {
          // 将此事件广播到eventHub上
          this.$eventHub.$emit('scrollToBottom')
        }
      }
    }
  }
</script>

<style>
  .ellipse2 {
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
  }

  .ellipse {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap
  }
  html, body {
    height: 100%;
    width: 100%;
    min-width: 1350px;
    background-color: #f4f5f6 !important;
  }

  .app-main {
    height: 100%;
  }
  .ivu-modal-footer{
    padding: 0!important;
  }
  .ivu-form-item{
    width: 337.5px;
    margin: 0 auto;
  }
  .ivu-form-item:first-child{
    margin-bottom: 20px;
  }
  .ivu-form-item:last-child{
    margin-top: 29px;
  }
  .ivu-form-item:nth-of-type(3){
    margin-top: 10px;
  }
  .ivu-form-item-content{
    display: flex;
  }
  .ivu-input{
    height: 45px;
  }
  .ivu-btn{
    height: 45px;
    font-size:22.5px;
  }
  .question-desc audio{
    margin: 10px 0;
  }
</style>
<style lang="less">
  @import "./common/style/variables";
  .form-photo {
    .ivu-upload-drag {
      overflow: visible !important;
    }
  }
  .forgetPwd {
    .form-box .ivu-form-item {
      width: 600px * @scaleRate !important;
    }
  }
  .ivu-upload-drag {
    border: none !important;
  }
  .ivu-upload-drag:hover {
    border: none !important;
  }
  .form-box {
    .ivu-form-item-content {
      align-items: center !important;
      height: 60px * @scaleRate !important;
    }
    .ivu-input {
      padding: 0 20px * @scaleRate !important;
      border-radius: 3px !important;
      font-size: 12px !important;
    }
    .label {
      font-size: 15px !important;
      color: #111111 !important;
      flex-shrink: 0 !important;
      font-weight: bold !important;
      margin-right: 30px * @scaleRate !important;
    }
    .ivu-form-item-required .ivu-form-item-label:before{
      content: '' !important;
    }
    .ivu-form-item{
      margin-bottom: 30px * @scaleRate !important;
      position: relative !important;
      width: 750px * @scaleRate !important;
    }
    .code-form {
      .ivu-input {
        width: 270px * @scaleRate !important;
      }
    }
    .ivu-input-wrapper {
      .ivu-input {
        width: 450px * @scaleRate;
        height: 60px * @scaleRate !important;
      }
    }
    .ivu-form-item-error-tip{
      left: 100px !important;
    }
  }
  .login-org, .login-wx {
    #goLogin{
      margin-bottom: 0 !important;
      .ivu-btn{
        font-size: 15px;
      }
    }
    .ivu-input {
      height: 60px * @scaleRate !important;
    }
    .ivu-form-item {
      margin-bottom: 20px !important;
    }
    .forget {
      margin-bottom: 52px * @scaleRate !important;
    }
  }
</style>



// WEBPACK FOOTER //
// src/App.vue